import type { Apartment } from "@/types";

const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});
const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  maximumFractionDigits: 1,
});

export function ApartmentPopup({ apartment }: { apartment: Apartment }) {
  const overbidPct = apartment.selling_price / apartment.list_price - 1;
  return (
    <table className="[&>td]:px-1">
      <thead>
        <tr>
          <th colSpan={2}>
            <a
              href={apartment.funda_link}
              rel="noopener noreferrer nofollow"
              target="_blank"
              className="underline"
            >
              {apartment.address}
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Sold on</td>
          <td className="text-right">{apartment.sold_on}</td>
        </tr>
        <tr>
          <td>m²</td>
          <td className="text-right">{apartment.meters}</td>
        </tr>
        <tr>
          <td>Asking price</td>
          <td className="text-right">
            {numberFormatter.format(apartment.list_price)}
          </td>
        </tr>
        <tr>
          <td>Selling price</td>
          <td className="text-right">
            {numberFormatter.format(apartment.selling_price)}
          </td>
        </tr>
        <tr>
          <td>Selling price/m²</td>
          <td className="text-right">
            {numberFormatter.format(apartment.selling_price_per_meter)}
          </td>
        </tr>
        <tr>
          <td>Overbid</td>
          <td className="text-right">{percentFormatter.format(overbidPct)}</td>
        </tr>
      </tbody>
    </table>
  );
}
